import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { usePathContext } from '../../../../context/PathContext.js';
import classNames from 'classnames';
import TimedProgression from './TimedProgression/index.js';
import PlainText from '../../../../components/PlainText/index.js';
import ContinueButtonProgression from './ContinueButtonProgression/index.js';
import ImageTextBlocks from './ImageTextBlocks/index.js';
import useSubmitInterstitialCommand from '../../../../commands/useSubmitInterstitialCommand.js';
import styles from './styles.css.js';

var InterstitialViewModel = function InterstitialViewModel(_ref) {
  var interstitialNodeViewModel = _ref.interstitialNodeViewModel;

  var _a, _b, _c, _d;

  var pathContext = usePathContext();

  var _useSubmitInterstitia = useSubmitInterstitialCommand({
    pathNodeId: interstitialNodeViewModel.id
  }),
      _useSubmitInterstitia2 = _slicedToArray(_useSubmitInterstitia, 2),
      submitInterstitialCommand = _useSubmitInterstitia2[0],
      loading = _useSubmitInterstitia2[1].loading;

  var interstitialResult = interstitialNodeViewModel.result;
  var currentNodeIndexInPathGraph = (_a = pathContext.pathGraphFlow) === null || _a === void 0 ? void 0 : _a.nodes.findIndex(function (node) {
    return node.id === interstitialNodeViewModel.id;
  });
  var isBackVisible = currentNodeIndexInPathGraph && !!((_b = pathContext.pathGraphFlow) === null || _b === void 0 ? void 0 : _b.nodes[currentNodeIndexInPathGraph + 1]);
  return React.createElement("div", {
    className: styles.page
  }, !!((_c = interstitialResult.headerText) === null || _c === void 0 ? void 0 : _c.plainText) && React.createElement("div", {
    className: classNames(styles.header, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement === 'default'))
  }, React.createElement(PlainText, {
    plainTextEntry: interstitialResult.headerText
  })), !!((_d = interstitialResult.subHeaderText) === null || _d === void 0 ? void 0 : _d.plainText) && React.createElement("div", {
    className: classNames(styles.body, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement === 'default'))
  }, React.createElement(PlainText, {
    plainTextEntry: interstitialResult.subHeaderText
  })), interstitialResult.blocks.length > 0 && React.createElement(ImageTextBlocks, {
    blocks: interstitialResult.blocks
  }), interstitialResult.progression.__typename === 'TimedContinueInterstitialProgressionPathNodeFlowViewModel' && React.createElement(TimedProgression, {
    loading: loading,
    timedProgression: interstitialResult.progression,
    isBackVisible: !!isBackVisible,
    onSubmit: function onSubmit() {
      return submitInterstitialCommand();
    }
  }), interstitialResult.progression.__typename === 'ContinueButtonInterstitialProgressionPathNodeFlowViewModel' && React.createElement(ContinueButtonProgression, {
    loading: loading,
    continueProgression: interstitialResult.progression,
    isBackVisible: !!isBackVisible,
    onSubmit: function onSubmit() {
      return submitInterstitialCommand();
    }
  }));
};

export default InterstitialViewModel;
//# sourceMappingURL=index.js.map
